// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TagsCustom_list__SfdcO {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  position: relative;
}
.TagsCustom_list__SfdcO li {
  -webkit-user-select: none;
          user-select: none;
  padding: 0;
  margin-bottom: 10px;
}
.TagsCustom_list__SfdcO li span:first-child {
  border-right: 1px solid white;
  padding: 3px 15px;
  display: inline-block;
  cursor: move;
}
.TagsCustom_list__SfdcO li span:nth-child(2) {
  padding: 0 5px;
  cursor: pointer;
}

.TagsCustom_dropDown__nNWui {
  margin: -1px 0 0 0;
  padding: 0;
  border: 1px solid #dee2e6;
  position: absolute;
  background: white;
  width: 100%;
}
.TagsCustom_dropDown__nNWui li {
  padding: 3px 10px;
  cursor: pointer;
}
.TagsCustom_dropDown__nNWui li:hover {
  background: #23AFD8;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/TagsCustom/TagsCustom.module.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AAHF;AAKE;EACE,yBAAA;UAAA,iBAAA;EACA,UAAA;EACA,mBAAA;AAHJ;AAKI;EACE,6BAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;AAHN;AAMI;EACE,cAAA;EACA,eAAA;AAJN;;AASA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AANF;AAQE;EACE,iBAAA;EACA,eAAA;AANJ;AAQI;EACE,mBAAA;EACA,WAAA;AANN","sourcesContent":[".input {\n\n}\n\n.list {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0;\n  padding: 0;\n  position: relative;\n\n  li {\n    user-select: none;\n    padding: 0;\n    margin-bottom: 10px;\n\n    span:first-child {\n      border-right: 1px solid white;\n      padding: 3px 15px;\n      display: inline-block;\n      cursor: move;\n    }\n\n    span:nth-child(2) {\n      padding: 0 5px;\n      cursor: pointer;\n    }\n  }\n}\n\n.dropDown {\n  margin: -1px 0 0 0;\n  padding: 0;\n  border: 1px solid #dee2e6;\n  position: absolute;\n  background: white;\n  width: 100%;\n\n  li {\n    padding: 3px 10px;\n    cursor: pointer;\n\n    &:hover {\n      background: #23AFD8;\n      color: #fff;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `TagsCustom_list__SfdcO`,
	"dropDown": `TagsCustom_dropDown__nNWui`
};
export default ___CSS_LOADER_EXPORT___;
